import {
  BriefcaseIcon,
  BuildingIcon,
  CalendarIcon,
  CreditCardIcon,
  GaugeIcon,
  GraduationCapIcon,
  HelpCircle,
  HelpCircleIcon,
  HomeIcon,
  LogOutIcon,
  MessageCircleMoreIcon,
  MessagesSquareIcon,
  QrCodeIcon,
  SettingsIcon,
  TicketIcon,
  TrophyIcon,
  UserIcon,
  UserPlusIcon,
  UsersIcon,
} from 'lucide-react';
import { cn } from '@sandtech-hub-monorepo/ui-kit';
import { Platform } from '../../utils';

export const getIcon = (app: string, classes?: string) => {
  const props = {
    className: 'text-foreground w-auto',
    size: 20,
  };

  if (classes) {
    props.className = cn(props.className, classes);
  }

  switch (app) {
    case 'UserIcon':
      return <UserIcon {...props} />;
    case 'SettingsIcon':
      return <SettingsIcon {...props} />;
    case 'HelpCircleIcon':
      return <HelpCircleIcon {...props} />;
    case 'LogOutIcon':
      return <LogOutIcon {...props} />;
    case 'HomeIcon':
      return <HomeIcon {...props} />;
    case 'GraduationCapIcon':
      return <GraduationCapIcon {...props} />;
    case 'CreditCardIcon':
      return <CreditCardIcon {...props} />;
    case 'CalendarIcon':
      return <CalendarIcon {...props} />;
    case 'GaugeIcon':
      return <GaugeIcon {...props} />;
    case 'MessageCircleMoreIcon':
      return <MessageCircleMoreIcon {...props} />;
    case 'UsersIcon':
      return <UsersIcon {...props} />;
    case 'UserPlusIcon':
      return <UserPlusIcon {...props} />;
    case 'BriefcaseIcon':
      return <BriefcaseIcon {...props} />;
    case 'TicketIcon':
      return <TicketIcon {...props} />;
    case 'HelpCircle':
      return <HelpCircle {...props} />;
    case 'BuildingIcon':
      return <BuildingIcon {...props} />;
    case 'RewardsIcon':
      return <TrophyIcon {...props} />;
    case 'CheckInIcon':
      return <QrCodeIcon {...props} />;
    case 'MessagesSquareIcon':
      return <MessagesSquareIcon {...props} />;
  }
};

export const LEGACY_PTS_MENU_ITEM_VALUE = 'legacyPoints';
export const NOTIFICATIONS_MENU_ITEM_VALUE = 'notifications';
export const APPS_MENU_ITEM_VALUE = 'applications';
export const SETTINGS_MENU_ITEM_VALUE = 'settings';

const PaywallDisabledInTheseLocationsRegexp =
  /^\/($|certificates\/.*|dashboards\/my_curriculums|surveys\/.*|users\/my_profile|nolearning|inactive)$/;

export const canPopupBeDisplayed = (platformId: Platform) => {
  return (
    [Platform.ATHENA].includes(platformId) &&
    // The regex must not match the path name in order for the paywall to show up.
    !PaywallDisabledInTheseLocationsRegexp.test(
      window?.location?.pathname || ''
    )
  );
};

export const isPaywallOpen = (
  noPaymentPlan: boolean,
  paymentPlanAtRisk: boolean | undefined,
  skipPaywallUntil: Date | undefined,
  platformId?: Platform,
  inHeader?: boolean
) => {
  return (
    (!skipPaywallUntil || new Date(skipPaywallUntil) < new Date()) &&
    (!!paymentPlanAtRisk || noPaymentPlan) &&
    (!(inHeader && platformId) || canPopupBeDisplayed(platformId))
  );
};
